import { create } from "zustand";

export const useAccessDeniedStore = create((set) => ({
    isOpen: false,
    show: () => set({ isOpen: true }),
    hide: () => set({ isOpen: false }),
}));
